enum PageTitle {
  MainPage = '文書一覧',
  UserList = 'ユーザー一覧',
  ShippingAddressList = '集配先一覧',
  TagMaintenance = 'タグメンテナンス',
  DocTypeList = '文書種類一覧',
  PermissionTemplateCreation = '権限テンプレート',
  ConfirmedRequestList = '確定済依頼一覧',
  OperationLogList = '操作ログ一覧',
  BulkMaintenanceSearchList = '一括メンテ検索一覧',
  BulkMaintenance = '一括メンテ実行',
  BulkMaintenanceResultList = '一括メンテ結果一覧',
  ExportLabel = '保管品ラベル発行',
  BulkMaintenanceSearchModal = '一括メンテ検索モーダル',
  AdminUserList = '管理者ユーザー一覧',
  SupplierList = '取引先一覧',
  GlobalIpRestriction = 'グローバルIPアドレス制限',
}

export default PageTitle;
